export const INVESTOR_WELCOME_PAGE_DESCRIPTION =
  'Your account is now setup, please continue into the platform to finalise the share exchange process';

export const FOUNDER_WELCOME_PAGE_DESCRIPTION = 'Your account is now setup';
